import React, { useState } from 'react';
import { FaUser,  FaStore, FaUsersBetweenLines, FaSitemap, FaUserSlash} from "react-icons/fa6";
import {GrView} from "react-icons/gr";
import {Customer, Seller, Provider,  Assoociate, Investment, Adminstrator, Family } from "../pageInside/Rolle"
import Modal from 'react-bootstrap/Modal'
import { isAuthenticated, SetElakayLang, getElakayLang, deleteUserById, getUsersByIds, getUserAddingRoleToken} from "../auth";
import { buildUserChoosingUrl } from "../../utils/userAddingRoleToken";
import { ROLE_CAPACITY_CONFIG } from "../pageInside/roleUser";
import UserAvatar from "../pageInside/UserAvatar";
import CardUserActivationModal from "../pageInside/CardUserActivationModal";
import EditRoleCapacityModal from "../pageInside/EditRoleCapacityModal";
import SuspendUserModal from "../pageInside/SuspendUserModal";
import "./Carduser.css"
import { elakayAutoText } from "./dataElakay";



let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["cardUser"]?.[key] || fallback;

// Formate une date en FR lisible pour le modal "View Hierarchy" — meme
// convention que jobApplicationsAdmin.jsx (formatDate).
const formatHierarchyDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};


const CardUSer = (props) => {
const { id } = getElakayLang();
const isNullOrEmpty = (value)=> {
  // Check for null, undefined, or false
  if (value == null || value === false || value === undefined) return true;

  // Check if the value is an empty object or array
  if (typeof value === 'object') {
      return Object.keys(value)?.length === 0;
  }
  // Otherwise, return false (the value is neither null, undefined, false, nor empty)
  return false;
}

 const { token } = isAuthenticated();
    const {
        userInfo,
        fullName,
        email,
        nbrUser = 0,
        getFilterOurTeam,
        setFilterOurTeam,
        User_id,
        loadAllMyUserRef,
        setFullName,
        setRoleName,
        setPageTeam,
        setPageProd,
        setPageShop,
        infoSource
    }= props
    __setElakayInfoSource(infoSource);
     const [error, setError] = useState(null);
      const [success, setSuccess] = useState(null);
    const LevelsPage = (Admintean = []) => {
let levels
let getLevel
      if(infoSource.userRole.roleName === 'Associate'){
        levels =[]
        getLevel = (adminTeamLength) => {
          
          if (adminTeamLength === 0 || adminTeamLength === 1 || adminTeamLength === 2 || adminTeamLength === 3) {
            return 1;
          } else if (adminTeamLength === 4) {
            return 2;
          }
        };
      }else if(infoSource.userRole.roleName === 'Investment'){
        levels = [
          { label: __elakayText("t011", "LEVEL 3"), color: "#60a5fa" }, // blue-400
          { label: __elakayText("t012", "LEVEL 4"), color: "#4ade80" }, // green-400
        ];
        
      getLevel = (adminTeamLength) => {
          
          if (adminTeamLength === 0 || adminTeamLength === 1 || adminTeamLength === 2 || adminTeamLength === 3) {
            return 1;
          } else if (adminTeamLength === 4) {
            return 2;
          }
        };

      }else if (infoSource.userRole.roleName === 'Administrator' ){
        levels = [
          { label: __elakayText("t013", "LEVEL 2"), color: "#f87171" }, // red-400
          { label: __elakayText("t011", "LEVEL 3"), color: "#60a5fa" }, // blue-400
          { label: __elakayText("t012", "LEVEL 4"), color: "#4ade80" }, // green-400
        ];
        
      getLevel = (adminTeamLength) => {
          
          if (adminTeamLength === 0 || adminTeamLength === 1 || adminTeamLength === 2) {
            return 1;
          } else if (adminTeamLength === 3) {
            return 2;
          } else if (adminTeamLength === 4) {
            return 3;
          }
        };

      }else{   
   levels = [
      { label: __elakayText("t014", "LEVEL 1"), color: "#483D8B" }, // orange-400
      { label: __elakayText("t013", "LEVEL 2"), color: "#f87171" }, // red-400
      { label: __elakayText("t011", "LEVEL 3"), color: "#60a5fa" }, // blue-400
      { label: __elakayText("t012", "LEVEL 4"), color: "#4ade80" }, // green-400
    ];

  getLevel = (adminTeamLength) => {
      
      if (adminTeamLength === 0 || adminTeamLength === 1) {
        return 1;
      } else if (adminTeamLength === 2) {
        return 2;
      } else if (adminTeamLength === 3) {
        return 3;
      } else if (adminTeamLength >= 4) {
        return 4;
      }
    };
  }


      const level = getLevel(Admintean);

      return (
        <div className="carduser-level-indicators">
          {levels?.map((lvl, index) => (
            <div
              key={index}
              className={`carduser-level-dot ${index < level ? 'carduser-level-active' : ''}`}
              style={{
                backgroundColor: index < level ? lvl.color : undefined,
                animationDelay: `${index * 0.2}s`
              }}
            />
          ))}
        </div>
      );
    };

    let userAgree = isNullOrEmpty(userInfo.userActiveRole.userActiveRole)

    const  newRole = (data)=>{
     if(userAgree){
      return {data, oldData: null,}
     }else{
      return {data: data.userActiveRole, oldData : data }
     }
    }
    // Cheap, list-level indicator only (userInfo.ativator[0], straight from
    // the bulk AllMyUserReF response -- token always stripped there, but
    // ativated/experyDate are not) -- drives the card's own status dot/icon
    // gating without a fetch per card in the list.
    let activatorIndicator = userInfo?.ativator?.[0]?.ativated

    let newUserInfo = newRole(userInfo.userActiveRole)

    let  roleName =  newUserInfo.data.roleName

    let roleLevel = roleName === 'Associate' || roleName === 'Investment' || roleName === 'Administrator'  || roleName === 'Family' ? true : false

    const [showLInkAdd, setShowLInkAdd] = useState(false)
    // The real activation token (User.ativator[].token — never
    // userActiveRole.role, never a connection JWT, never user.tokens) is not
    // present on `userInfo` (AllMyUserReF strips it) — fetched narrowly, on
    // demand, from the authorized getUserAddingRoleToken endpoint when the
    // activation modal opens. Carries ativated/startDate/experyDate alongside
    // the token so the modal's status (pending/expired/already used), Time
    // remaining countdown and Activity dates all reflect the *correctly
    // selected* ativator[] entry, not just index 0. startDate isn't a real
    // field on that subdocument -- the server derives it from the entry's
    // own ObjectId creation timestamp (see startDateFromAtivatorEntry).
    const [activator, setActivator] = useState(null)
    const [shareTokenLoading, setShareTokenLoading] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const openShareModal = () => {
        setShowLInkAdd(true)
        if (!activator && !shareTokenLoading) {
            setShareTokenLoading(true)
            getUserAddingRoleToken(token, userInfo._id).then((data) => {
                setActivator({
                    token: data?.token || null,
                    ativated: data?.ativated ?? null,
                    startDate: data?.startDate || null,
                    experyDate: data?.experyDate || null
                })
                setShareTokenLoading(false)
            })
        }
    }

    // Modal "View Hierarchy" : liste les utilisateurs references dans
    // userActiveRole.Admintean (cf. plan — meme principe que showLInkAdd).
    const [showHierarchy, setShowHierarchy] = useState(false)
    const [hierarchyLoading, setHierarchyLoading] = useState(false)
    const [hierarchyUsers, setHierarchyUsers] = useState([])
    const [hierarchyError, setHierarchyError] = useState(null)
    // 'graph' (organigramme) ou 'list' (table/cartes detaillees) — graph par defaut.
    const [hierarchyView, setHierarchyView] = useState('graph')
    const adminTeamIds = userInfo?.userActiveRole?.Admintean || []

    // Modal "Suspend" -- manual suspension system (Community Management >
    // View User). See includes/pageInside/SuspendUserModal.jsx.
    const [showSuspend, setShowSuspend] = useState(false)

    // Modal "Edit role limits" -- lets the acting admin edit this user's
    // team-managing limits (max Royalty/Seller/Producer/Associate/
    // Investment/Admin) + expiration from their own card, reusing the exact
    // same UpdateUserRoleByAdmin "edit existing account" branch
    // addAdminFamily.jsx's own email-lookup flow already relies on -- always
    // targets the user's REAL, currently active role (userInfo.userActiveRole,
    // top-level), never a still-pending proposal's role, so editing while a
    // proposal is outstanding replaces it rather than editing on top of it.
    const [showEditCapacity, setShowEditCapacity] = useState(false)
    const currentActiveRoleName = userInfo?.userActiveRole?.roleName

    // Same hierarchy addAdminFamily.jsx's formSelect() gates "add a role"
    // options behind (Assoociate()/Investment()/Adminstrator()/Family()) --
    // an admin may only edit a tier they'd also be allowed to add.
    const canEditRoleTier = (rn) => {
      if (rn === 'Royalty' || rn === 'Seller' || rn === 'Provider') return Assoociate()
      if (rn === 'Associate') return Investment()
      if (rn === 'Investment') return Adminstrator()
      if (rn === 'Administrator' || rn === 'Family') return Family()
      return false
    }
    const canEditCapacity = Boolean(ROLE_CAPACITY_CONFIG[currentActiveRoleName]) && canEditRoleTier(currentActiveRoleName)

    // Roles the acting admin may PROMOTE this user into from the edit
    // modal -- strictly superior to the target's current role level (never
    // the same tier, never a demotion) AND a tier the acting admin is
    // themselves allowed to grant (same canEditRoleTier gate used above).
    // Royalty..Family, in ascending level order -- mirrors
    // addAdminFamily.jsx's own selectRole 1..7 ordering.
    const ROLE_ASCENDING_ORDER = ['Royalty', 'Seller', 'Provider', 'Associate', 'Investment', 'Administrator', 'Family']
    const currentRoleLevel = ROLE_CAPACITY_CONFIG[currentActiveRoleName]?.level || 0
    const promotableRoles = ROLE_ASCENDING_ORDER.filter((rn) =>
      ROLE_CAPACITY_CONFIG[rn].level > currentRoleLevel && canEditRoleTier(rn)
    )

    const handleEditCapacitySuccess = () => {
      setShowEditCapacity(false)
      setSuccess(__elakayText("t042", "Role limits updated. Awaiting the user's acceptance."))
      // The activation link/countdown (activator) may now point at a
      // refreshed or brand-new token -- never keep showing the stale one
      // fetched before this edit (mission section 9). Cleared here so
      // reopening/staying on the activation modal re-fetches it fresh.
      setActivator(null)
      if (showLInkAdd) {
        setShareTokenLoading(true)
        getUserAddingRoleToken(token, userInfo._id).then((data) => {
          setActivator({
            token: data?.token || null,
            ativated: data?.ativated ?? null,
            startDate: data?.startDate || null,
            experyDate: data?.experyDate || null
          })
          setShareTokenLoading(false)
        })
      }
      loadAllMyUserRef && loadAllMyUserRef(getFilterOurTeam)
    }

    const openHierarchyModal = () => {
      setShowHierarchy(true)
      setHierarchyError(null)
      setHierarchyView('graph')
      setHierarchyLoading(true)
      getUsersByIds(token, adminTeamIds).then((data) => {
        if (data?.success) {
          setHierarchyUsers(data.users || [])
        } else {
          setHierarchyError(data?.error || __elakayText("t020", "Erreur lors du chargement de l'equipe."))
        }
        setHierarchyLoading(false)
      })
    }

  // Always window.location.origin (never a hardcoded host) — returns "" until
  // the real token has been fetched (see openShareModal), so this never
  // builds a link containing "undefined".
  let shareUrl = buildUserChoosingUrl(activator?.token)

  let chechProductView = !userAgree || !activatorIndicator || roleLevel ? true : false

    const statusClass = !activatorIndicator
      ? 'carduser-status-inactive'
      : !userAgree
        ? 'carduser-status-pending'
        : 'carduser-status-active';

const btnNotOk = (a)=>{
    if(a==='Royalty' || a==='Seller' || a==='Provider'){
        return false 
    }
    return true
}
const btnNotOk2 = (a)=>{
    if(a==='Royalty'){
        return false 
    }
    return true
}
const btnOrtherUser = ()=>{
    setPageTeam(true)
    setPageProd(false)
    setPageShop(false)
    setFullName(fullName)
    setRoleName(roleName)
   setFilterOurTeam({...getFilterOurTeam, userID: User_id})
   getFilterOurTeam.userID = User_id
   loadAllMyUserRef(getFilterOurTeam)

}

const btnShopUser = ()=>{
    setPageTeam(false)
    setPageProd(false)
    setPageShop(true)
    setFullName(fullName)
    setRoleName(roleName)
    setFilterOurTeam({...getFilterOurTeam, userID: User_id})
}
  const ProductView = (
    chechProductView &&  <div className="carduser-view-icon"><GrView onClick={openShareModal}/></div>

    )
      const btnCardUser = ()=>{
        return  <div className="carduser-actions">
             {btnNotOk(roleName) && <span className="carduser-action-btn"
                 onClick={btnOrtherUser}
                 >
                <FaUsersBetweenLines />
                </span>}

                {btnNotOk2(roleName) &&  <>
                <span
                  className="carduser-action-btn"
                  onClick={btnShopUser}
                 >
                <FaStore />
                </span></>}

                {adminTeamIds.length > 0 && <span
                  className="carduser-action-btn"
                  onClick={openHierarchyModal}
                  title={__elakayText("t021", "View Hierarchy")}
                 >
                <FaSitemap />
                </span>}

                <span
                  className="carduser-action-btn"
                  onClick={() => setShowSuspend(true)}
                  title={__elakayText("t038", "Suspend")}
                 >
                <FaUserSlash />
                </span>

                </div>
      }

    // Explicit, separate variables (mission section 11) — never mixing the
    // role's own start/end with the activation link's expiration, which
    // lives on `activator` (fetched separately, see openShareModal) and is
    // handled entirely inside ActivationShareActions/CardUserActivationModal.
    //
    // While a new role is still pending acceptance (!userAgree), the "live"
    // dates are the ones on the nested proposal (userInfo.userActiveRole.userActiveRole
    // -- see newRole() above), never the old/top-level role's -- same nested
    // slot UpdateUserRoleByAdmin's roleCreated branch writes the proposal
    // into server-side. Once accepted, that nested slot is gone (userAgree)
    // and the top-level role is the only one that matters.
    const pendingRoleProposal = !userAgree ? userInfo?.userActiveRole?.userActiveRole : null
    const roleStartDate = userInfo?.userActiveRole?.startDate
      ? new Date(userInfo.userActiveRole.startDate).getTime()
      : (pendingRoleProposal?.startDate ? new Date(pendingRoleProposal.startDate).getTime() : null)
    const roleEndDate = !isNullOrEmpty(userInfo?.userActiveRole?.endDate)
      ? new Date(userInfo.userActiveRole.endDate).getTime()
      : (pendingRoleProposal?.experyDate ? new Date(pendingRoleProposal.experyDate).getTime() : null)

    // Mirrors the mission's canDeleteExpiredInvitation formula, using the
    // fetched (correctly-selected) activator entry rather than a raw index-0
    // read — only offered once that entry is known to be expired and unused.
    const activationAlreadyCompleted = Boolean(activator?.ativated)
    const activationTimeRemaining = activator?.experyDate ? new Date(activator.experyDate).getTime() - Date.now() : null
    const canDeleteExpiredInvitation = !activationAlreadyCompleted && activationTimeRemaining !== null && activationTimeRemaining <= 0

    const handleDeleteExpiredUser = async () => {
        try {
            setDeleteLoading(true)
            await deleteUserById(User_id, token, setError, setSuccess)
            await loadAllMyUserRef(getFilterOurTeam)
            setShowLInkAdd(false)
        } finally {
            setDeleteLoading(false)
        }
    }

      const infonLinkAdd = ()=> (
        <CardUserActivationModal
          show={showLInkAdd}
          onHide={() => setShowLInkAdd(false)}
          infoSource={infoSource}
          userInfo={userInfo}
          userId={User_id}
          fullName={fullName}
          email={email}
          roleName={roleName}
          numberOfTeamMembers={nbrUser}
          oldRoleData={newUserInfo.oldData}
          newRoleData={newUserInfo.data}
          userAgree={userAgree}
          activator={activator}
          shareUrl={shareUrl}
          shareLoading={shareTokenLoading}
          roleStartDate={roleStartDate}
          roleEndDate={roleEndDate}
          error={error}
          success={success}
          onDismissError={() => setError(null)}
          onDismissSuccess={() => setSuccess(null)}
          onShareCopied={() => setSuccess(__elakayText("t039", "Activation link copied."))}
          onShareError={() => setError(__elakayText("t040", "Unable to share this activation link."))}
          canDelete={canDeleteExpiredInvitation}
          deleteLoading={deleteLoading}
          onDelete={handleDeleteExpiredUser}
          canEditCapacity={canEditCapacity}
          onEditCapacity={() => setShowEditCapacity(true)}
        />
      )

      // Modal "View Hierarchy" — liste les utilisateurs de Admintean.
      // Desktop (>768px) : table ; mobile (<=768px) : cartes. Pas de
      // composant table->card existant dans le projet (verifie), donc deux
      // rendus paralleles comme dans le reste du codebase (cf. plan).
      // Organigramme : la carte racine (l'utilisateur courant) en haut,
      // connectee par des lignes CSS a chaque membre de Admintean en
      // dessous. Pas de lib de graphe dans le projet (verifie) — un arbre
      // a 2 niveaux n'en a pas besoin, CSS pur reste leger.
      const hierarchyGraph = () => (
        <div className="carduser-hierarchy-graph">
          <div className="carduser-hierarchy-node carduser-hierarchy-node--root">
            <span className="carduser-hierarchy-node-avatar"><FaUser /></span>
            <span className="carduser-hierarchy-node-name">{fullName}</span>
            <span className="carduser-hierarchy-node-role">{roleName}</span>
          </div>
          <div className="carduser-hierarchy-graph-children">
            {hierarchyUsers.map((u) => {
              const active = u.ativator?.[0]?.ativated
              return (
                <div className="carduser-hierarchy-branch" key={u._id}>
                  <div
                    className={`carduser-hierarchy-node ${active ? "carduser-hierarchy-node--active" : "carduser-hierarchy-node--inactive"}`}
                    role="button"
                    onClick={btnOrtherUser}
                  >
                    <span className="carduser-hierarchy-node-avatar"><FaUser /></span>
                    <span className="carduser-hierarchy-node-name">{`${u.firstname || ""} ${u.lastname || ""}`.trim()}</span>
                    <span className="carduser-hierarchy-node-role">{u.userActiveRole?.roleName || u.userActiveRole?.actRole}</span>
                    <span className="carduser-hierarchy-node-meta">
                      {__elakayText("t028", "Niveau")} {u.userActiveRole?.level ?? "-"} · {infoSource.language(infoSource, "title", "nbrTeam")}: {u.nombreTeam ?? 0}
                    </span>
                    <span className={`carduser-hierarchy-pill ${active ? "carduser-hierarchy-pill--active" : "carduser-hierarchy-pill--inactive"}`}>
                      {active ? __elakayText("t031", "Active") : __elakayText("t032", "Inactive")}
                    </span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )

      const hierarchyModal = () => {
        return <Modal
          show={showHierarchy}
          onHide={() => setShowHierarchy(false)}
          dialogClassName="carduser-hierarchy-modal"
          aria-labelledby="carduser-hierarchy-modal-title"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="carduser-hierarchy-modal-title">
              {__elakayText("t022", "Team Hierarchy")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!hierarchyLoading && !hierarchyError && hierarchyUsers.length > 0 && (
              <div className="carduser-hierarchy-toggle">
                <button
                  type="button"
                  className={`carduser-hierarchy-toggle-btn ${hierarchyView === 'graph' ? 'carduser-hierarchy-toggle-btn--active' : ''}`}
                  onClick={() => setHierarchyView('graph')}
                >
                  {__elakayText("t033", "Graph")}
                </button>
                <button
                  type="button"
                  className={`carduser-hierarchy-toggle-btn ${hierarchyView === 'list' ? 'carduser-hierarchy-toggle-btn--active' : ''}`}
                  onClick={() => setHierarchyView('list')}
                >
                  {__elakayText("t034", "Liste")}
                </button>
              </div>
            )}

            {hierarchyLoading && (
              <div className="carduser-hierarchy-empty">
                {__elakayText("t023", "Chargement...")}
              </div>
            )}

            {!hierarchyLoading && hierarchyError && (
              <div className="carduser-hierarchy-error">{hierarchyError}</div>
            )}

            {!hierarchyLoading && !hierarchyError && hierarchyUsers.length === 0 && (
              <div className="carduser-hierarchy-empty">
                {__elakayText("t024", "Aucun membre dans cette equipe.")}
              </div>
            )}

            {!hierarchyLoading && !hierarchyError && hierarchyUsers.length > 0 && hierarchyView === 'graph' && hierarchyGraph()}

            {!hierarchyLoading && !hierarchyError && hierarchyUsers.length > 0 && hierarchyView === 'list' && (
              <>
                <table className="carduser-hierarchy-table">
                  <thead>
                    <tr>
                      <th>{__elakayText("t025", "Nom complet")}</th>
                      <th>{__elakayText("t026", "Email")}</th>
                      <th>{__elakayText("t027", "Role")}</th>
                      <th>{__elakayText("t028", "Niveau")}</th>
                      <th>{__elakayText("t029", "Debut")}</th>
                      <th>{__elakayText("t030", "Active")}</th>
                      <th>{infoSource.language(infoSource, "title", "nbrTeam")}</th>
                      <th>{__elakayText("t035", "Equipe")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hierarchyUsers.map((u) => (
                      <tr key={u._id}>
                        <td>{`${u.firstname || ""} ${u.lastname || ""}`.trim()}</td>
                        <td>{u.email}</td>
                        <td>{u.userActiveRole?.roleName || u.userActiveRole?.actRole}</td>
                        <td>{u.userActiveRole?.level ?? "-"}</td>
                        <td>{formatHierarchyDate(u.userActiveRole?.startDate)}</td>
                        <td>
                          <span className={`carduser-hierarchy-pill ${u.ativator?.[0]?.ativated ? "carduser-hierarchy-pill--active" : "carduser-hierarchy-pill--inactive"}`}>
                            {u.ativator?.[0]?.ativated
                              ? formatHierarchyDate(u.ativator[0].activatedDate) || __elakayText("t031", "Active")
                              : __elakayText("t032", "Inactive")}
                          </span>
                        </td>
                        <td>{u.nombreTeam ?? 0}</td>
                        <td>
                          <span className="carduser-hierarchy-link" role="button" onClick={btnOrtherUser}>
                            <FaUsersBetweenLines />
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="carduser-hierarchy-cards">
                  {hierarchyUsers.map((u) => (
                    <div className="carduser-hierarchy-card" key={u._id}>
                      <h5>{`${u.firstname || ""} ${u.lastname || ""}`.trim()}</h5>
                      <p>{u.email}</p>
                      <div className="carduser-hierarchy-card-row">
                        <span>{__elakayText("t027", "Role")}</span>
                        <span>{u.userActiveRole?.roleName || u.userActiveRole?.actRole}</span>
                      </div>
                      <div className="carduser-hierarchy-card-row">
                        <span>{__elakayText("t028", "Niveau")}</span>
                        <span>{u.userActiveRole?.level ?? "-"}</span>
                      </div>
                      <div className="carduser-hierarchy-card-row">
                        <span>{__elakayText("t029", "Debut")}</span>
                        <span>{formatHierarchyDate(u.userActiveRole?.startDate)}</span>
                      </div>
                      <div className="carduser-hierarchy-card-row">
                        <span>{__elakayText("t030", "Active")}</span>
                        <span className={`carduser-hierarchy-pill ${u.ativator?.[0]?.ativated ? "carduser-hierarchy-pill--active" : "carduser-hierarchy-pill--inactive"}`}>
                          {u.ativator?.[0]?.ativated
                            ? formatHierarchyDate(u.ativator[0].activatedDate) || __elakayText("t031", "Active")
                            : __elakayText("t032", "Inactive")}
                        </span>
                      </div>
                      <div className="carduser-hierarchy-card-row">
                        <span>{infoSource.language(infoSource, "title", "nbrTeam")}</span>
                        <span>{u.nombreTeam ?? 0}</span>
                      </div>
                      <span className="carduser-hierarchy-link" role="button" onClick={btnOrtherUser}>
                        <FaUsersBetweenLines /> {__elakayText("t035", "Equipe")}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      }

const cardInside = () =>{
        return <div className={`carduser-container ${statusClass}`}>
          <div className="carduser-circle">
             <UserAvatar userId={User_id} fullName={fullName} />
          </div>
          <div className="carduser-info-rectangle">
            <div className="carduser-info-top">
              <h3 className="carduser-name">{fullName}</h3>
              <span className="carduser-role">{roleName || __elakayText("t037", "User")}</span>
              <h6 className="carduser-email">{email}</h6>
              <p className="carduser-team-count"> {infoSource.language(infoSource, "title", "nbrTeam")}: {nbrUser}</p>
              {userInfo.suspensionStatus === 'suspended' && <span className="badge bg-danger">{elakayAutoText("h_794696a720669c", "Suspended")}</span>}
              {userInfo.suspensionStatus === 'scheduled' && <span className="badge bg-warning text-dark">{elakayAutoText("h_739e54e7669cd6", "Suspension Scheduled")}</span>}
            </div>
            <div className="carduser-info-bottom">
              {btnCardUser()}
              {LevelsPage(userInfo.userActiveRole.Admintean?.length)}
            </div>
          </div>
          {ProductView}
        </div>

}

         return (<div>
{ cardInside()}
          {infonLinkAdd()}
          {hierarchyModal()}
          <SuspendUserModal
            show={showSuspend}
            onHide={() => setShowSuspend(false)}
            token={token}
            userId={User_id}
            userFullName={fullName}
            infoSource={infoSource}
            onSuspended={loadAllMyUserRef ? () => loadAllMyUserRef(getFilterOurTeam) : undefined}
          />
          <EditRoleCapacityModal
            show={showEditCapacity}
            onHide={() => setShowEditCapacity(false)}
            infoSource={infoSource}
            token={token}
            targetUserId={User_id}
            targetFirstName={userInfo.firstname}
            targetLastName={userInfo.lastname}
            targetEmail={email}
            roleName={currentActiveRoleName}
            promotableRoles={promotableRoles}
            currentLimits={{
              maxRoyalite: userInfo?.userActiveRole?.maxRoyalite,
              maxSeller: userInfo?.userActiveRole?.maxSeller,
              maxProducer: userInfo?.userActiveRole?.maxProducer,
              maxAssociate: userInfo?.userActiveRole?.maxAssociate,
              maxInvestment: userInfo?.userActiveRole?.maxInvestment,
              maxAdmin: userInfo?.userActiveRole?.maxAdmin,
            }}
            onSuccess={handleEditCapacitySuccess}
          />
        </div>)
}

export default CardUSer;
